import type { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import { twJoin } from 'tailwind-merge'
import EmptyListIcon from 'shared/icons/empty-list-icon'

interface MembersEmptyListProps {
  small?: boolean
  title?: string
  description?: string
}

export const MembersEmptyList = ({
  small,
  title,
  description,
}: MembersEmptyListProps): ReactNode => {
  const { t } = useTranslation()
  return (
    <div
      className={twJoin(
        `flex w-full flex-col items-center justify-center gap-3 rounded-md bg-bg-primary`,
        small ? 'py-10' : 'py-20',
      )}
    >
      <EmptyListIcon className={small ? 'size-32' : ''} />
      <div className="flex flex-col items-center">
        <span className="text-base font-medium text-text-primary">
          {title ?? t('global.list.empty_title')}
        </span>
        <span className="text-sm text-text-tertiary">
          {description ?? t('global.list.empty_list')}
        </span>
      </div>
    </div>
  )
}
